import * as types from '../../constants/ActionTypes'
import { createBasicCreator, fetchData } from '../Buy'

export const setCodicePreventivo = createBasicCreator(
  types.SET_CODICE_PREVENTIVO
)

export const getOrdiniCodicePreventivo = (dispatch, getState) => {
  const codicePreventivo = getState().ordine.codice_preventivo
  const idAuto = getState().product.id_auto
  const uri = `${
    window.brumbrum.url_api
  }/ordini/p/v1/codici/${codicePreventivo}/${idAuto}?v=${new Date().getTime()}`
  return dispatch(
    fetchData(types.GET_ORDINI_CODICE_PREVENTIVO)({
      callback: types.GET_ORDINI_CODICE_PREVENTIVO,
      errorMessage: types.GET_ORDINI_CODICE_PREVENTIVO,
      method: 'GET',
      uri,
    })
  )
}

export const getOrdineAfterRestore = (dispatch, getState, _idOrdine) => {
  const idOrdine = _idOrdine || getState().ordine.id_ordine
  const uri = `${
    window.brumbrum.url_api
  }/ordini/t/v1/ordini/${idOrdine}?v=${new Date().getTime()}`
  return dispatch(
    fetchData(types.GET_ORDINE_AFTER_RESTORE)({
      callback: types.GET_ORDINE_AFTER_RESTORE,
      errorMessage: types.GET_ORDINE_AFTER_RESTORE,
      method: 'GET',
      uri,
    })
  )
}
